// components/TenantLanding/Login/RegisterForms/Account1.js
import React from "react";

const COUNTRY_CODE_OPTIONS = [
  { value: "+91", label: "+91 (India)" },
  { value: "+1", label: "+1 (USA/Canada)" },
  { value: "+44", label: "+44 (UK)" },
  { value: "+61", label: "+61 (Australia)" },
  { value: "+971", label: "+971 (UAE)" },
  { value: "+966", label: "+966 (Saudi Arabia)" },
  { value: "+65", label: "+65 (Singapore)" },
  { value: "+60", label: "+60 (Malaysia)" },
  { value: "+86", label: "+86 (China)" },
  { value: "+81", label: "+81 (Japan)" },
  { value: "+82", label: "+82 (South Korea)" },
  { value: "+33", label: "+33 (France)" },
  { value: "+49", label: "+49 (Germany)" },
  { value: "+39", label: "+39 (Italy)" },
];

const TWO_FACTOR_OPTIONS = [
  { value: "Authenticator", label: "Authenticator App" },
  { value: "SMS", label: "SMS" },
  { value: "Email", label: "Email" },
];

const Account1 = ({
  formData,
  errors,
  loading,
  handleChange,
  otpSent,
  otpVerified,
  otpValue,
  setOtpValue,
  handleEmailCheck,
  handleVerifyOTP,
  handleResendOTP,
  showPassword,
  setShowPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  handleNext,
  handlePrevious,
  isEditMode = false,
  emailChanged = false,
  isEmailLocked = false,
   originalEmail = '',
}) => {
  const requiresOtp = !isEditMode || (emailChanged && !isEmailLocked);
  
  // Add this near the top of Account1 component
const isOtpDisabled = loading || 
  (requiresOtp && otpVerified) || 
  (isEditMode && !emailChanged) || 
  !formData.email;

  return (
    <div className="register-stage1-form__section">
      <h3 className="register-stage1-form__section-title">🔐 Account Access</h3>
      <p className="register-stage1-form__section-subtitle">
        Primary login and communication channel.
      </p>

      <div className="register-stage1-form__row">
        <div className="register-stage1-form__col-full">
  <div className="register-stage1-form__field-group">
    <label className="register-stage1-form__label">
      Email Address <span className="register-stage1-form__required">*</span>
    </label>

<div className="register-stage1-form__email-group">
  <input
    type="email"
    name="email"
    className={`register-stage1-form__input ${errors.email ? "register-stage1-form__input--error" : ""}`}
    value={formData.email}
    onChange={handleChange}
    placeholder="name@example.com"
    disabled={loading || isEmailLocked || (requiresOtp && otpVerified)}
  />
  {requiresOtp && !isEmailLocked && (
    <button
      type="button"
      className="register-stage1-form__btn register-stage1-form__btn--check-email"
      onClick={handleEmailCheck}
      disabled={isOtpDisabled}
    >
      {loading ? "Checking..." : otpVerified ? "✓ Verified" : "Check & Send OTP"}
    </button>
  )}
</div>
    {errors.email && (
      <span className="register-stage1-form__error-text">{errors.email}</span>
    )}
    {isEmailLocked && (
      <small className="register-stage1-form__help-text">
        Your application is under review after being returned. Email cannot be changed at this stage.
      </small>
    )}
    {isEditMode && !isEmailLocked && !emailChanged && (
      <small className="register-stage1-form__help-text">
        This is your current verified email. Change it if you'd like to update your login email.
      </small>
    )}
    {!isEditMode && (
      <small className="register-stage1-form__help-text">
        This will be your primary login. Do not use a shared office email as the only login.
      </small>
    )}
    {isEditMode && !isEmailLocked && emailChanged && (
      <small className="register-stage1-form__help-text">
        You've changed your email — please verify it with an OTP before continuing.
      </small>
    )}
   {/* Show warning when email is changed in edit mode */}
{isEditMode && !isEmailLocked && emailChanged && originalEmail && (
  <div className="register-stage1-form__warning-text" style={{ color: '#856404', backgroundColor: '#fff3cd', padding: '8px 12px', borderRadius: '4px', marginTop: '8px', fontSize: '14px' }}>
    ⚠️ You've changed your email from <strong>{originalEmail}</strong> to <strong>{formData.email}</strong>. 
    Please verify the new email with OTP.
  </div>
)}
  </div>
</div>

        {/* OTP Section */}
        {requiresOtp && otpSent && !otpVerified && (
          <div className="register-stage1-form__col-full">
            <div className="register-stage1-form__otp-section">
              <div className="register-stage1-form__field-group">
                <label className="register-stage1-form__label">
                  Verification Code <span className="register-stage1-form__required">*</span>
                </label>
                <div className="register-stage1-form__otp-group">
                  <input
                    type="text"
                    name="otp"
                    className={`register-stage1-form__input register-stage1-form__input--otp ${errors.otp ? "register-stage1-form__input--error" : ""}`}
                    value={otpValue}
                    onChange={(e) => setOtpValue(e.target.value.replace(/\D/g, "").slice(0, 6))}
                    placeholder="Enter 6-digit OTP"
                    disabled={loading}
                    maxLength="6"
                    autoFocus
                  />
                  <button
                    type="button"
                    className="register-stage1-form__btn register-stage1-form__btn--verify-otp"
                    onClick={handleVerifyOTP}
                    disabled={loading || otpValue.length < 4}
                  >
                    {loading ? "Verifying..." : "Verify OTP"}
                  </button>
                </div>
                {errors.otp && (
                  <span className="register-stage1-form__error-text">{errors.otp}</span>
                )}
                <small className="register-stage1-form__help-text">
                  Enter the 6-digit code sent to your email.{" "}
                  <button
                    type="button"
                    className="register-stage1-form__resend-btn"
                    onClick={handleResendOTP}
                    disabled={loading}
                  >
                    Resend OTP
                  </button>
                </small>
              </div>
            </div>
          </div>
        )}

        {/* OTP Verified Status — only meaningful when verification was actually required */}
        {requiresOtp && otpVerified && (
          <div className="register-stage1-form__col-full">
            <div className="register-stage1-form__verified-badge">
              <span className="register-stage1-form__verified-icon">✅</span>
              <span>Email verified successfully!</span>
            </div>
          </div>
        )}

        <div className="register-stage1-form__col-30">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Country Code <span className="register-stage1-form__required">*</span>
            </label>
            <select
              name="mobile_country_code"
              className="register-stage1-form__select"
              value={formData.mobile_country_code}
              onChange={handleChange}
              disabled={loading}
            >
              {COUNTRY_CODE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="register-stage1-form__col-70">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Mobile Number <span className="register-stage1-form__required">*</span>
            </label>
            <input
              type="tel"
              name="mobile_number"
              className={`register-stage1-form__input ${errors.mobile_number ? "register-stage1-form__input--error" : ""}`}
              value={formData.mobile_number}
              onChange={handleChange}
              placeholder="10–15 digits"
              disabled={loading}
            />
            {errors.mobile_number && (
              <span className="register-stage1-form__error-text">{errors.mobile_number}</span>
            )}
            <small className="register-stage1-form__help-text">
              Used for login recovery and mobilisation contact.
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              {isEditMode ? "New Password" : "Password"}{" "}
              {!isEditMode && <span className="register-stage1-form__required">*</span>}
            </label>
            <div className="register-stage1-form__password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className={`register-stage1-form__input ${errors.password ? "register-stage1-form__input--error" : ""}`}
                value={formData.password}
                onChange={handleChange}
                placeholder={isEditMode ? "Leave blank to keep current password" : "Minimum 8 characters"}
                disabled={loading}
              />
              <button
                type="button"
                className="register-stage1-form__password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
            {errors.password && (
              <span className="register-stage1-form__error-text">{errors.password}</span>
            )}
            <small className="register-stage1-form__help-text">
              {isEditMode
                ? "Only fill this in if you want to change your password."
                : "Must be at least 8 characters with strength rules."}
            </small>
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">
              Confirm Password{" "}
              {!isEditMode && <span className="register-stage1-form__required">*</span>}
            </label>
            <div className="register-stage1-form__password-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirm_password"
                className={`register-stage1-form__input ${errors.confirm_password ? "register-stage1-form__input--error" : ""}`}
                value={formData.confirm_password}
                onChange={handleChange}
                placeholder="Confirm your password"
                disabled={loading}
              />
              <button
                type="button"
                className="register-stage1-form__password-toggle"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                disabled={loading}
              >
                {showConfirmPassword ? "🙈" : "👁️"}
              </button>
            </div>
            {errors.confirm_password && (
              <span className="register-stage1-form__error-text">{errors.confirm_password}</span>
            )}
          </div>
        </div>

        <div className="register-stage1-form__col-half">
          <div className="register-stage1-form__field-group">
            <label className="register-stage1-form__label">Two-Factor Authentication</label>
            <select
              name="mfa_method"
              className="register-stage1-form__select"
              value={formData.mfa_method}
              onChange={handleChange}
              disabled={loading}
            >
              {TWO_FACTOR_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <small className="register-stage1-form__help-text">
              Authenticator application is preferred for security.
            </small>
          </div>
        </div>
      </div>

      <div className="register-stage1-form__actions">
        <button
          type="button"
          className="register-stage1-form__btn register-stage1-form__btn--outline"
          onClick={handlePrevious}
          disabled={loading}
        >
          Cancel
        </button>
       <button
  type="button"
  className="register-stage1-form__btn register-stage1-form__btn--primary"
  onClick={handleNext}
  disabled={loading || (requiresOtp && !otpVerified)}
>
  Continue →
</button>
      </div>
    </div>
  );
};

export default Account1;